import { storage } from '@/services/storage'
import { funnels }   from "@/services/axios"

export const menu = {
    namespaced: true,
    state: {
        menu: {}
    },

    getters: {
        getMenu(state){
            return state.menu
        }
    },

    mutations: {
        SET_MENU_CONFIG(state, payload) {
            state.menu = payload
        }
    },

    actions: {
        setMenu({ commit }, payload) {
           funnels.getAllFunnels().then(async (response) => {
               let funnelMenu = payload.navigation[0].submenu.categories.find(item => item.title ==  'Funil').navigation[0];
                payload.navigation[0].submenu.categories.find(item => item.title ==  'Funil').navigation = response?.data?.data;
                    payload.navigation[0].submenu.categories[0].navigation = payload.navigation[0].submenu.categories.find(item => item.title ==  'Funil')?.navigation?.map((item) => {
                        return {
                                    "id": item.id,
                                    "name": item.name,
                                    "label": item.name,
                                    "main": item.main,
                                    "allowed": true,
                                    "created_at": item.created_at,
                                    "updated_at": item.updated_at,
                                    "v2": true,
                                    "new": false,
                                    "link": 'sales.deals.funnel',
                                    "params":{
                                        "funnel_id": item.id,
                                    },
                                    "slug": item.id,
                                    "allowed_to": [],
                                    "allowed_to_except": []
                                }
                    })
                payload.navigation[0].submenu.categories[0].navigation.unshift(funnelMenu);
                let filter = []
                const user = JSON.parse(storage.get('user_logged'))
                const configsData = storage.get('get-configs-data')
                    ? JSON.parse(storage.get('get-configs-data'))
                    : {}
    
                // Verifica se foram configurados relatórios do tipo BI
                if (Object.prototype.hasOwnProperty.call(configsData, 'configReportsBI') &&
                    configsData['configReportsBI']) {
                    const config = configsData['configReportsBI']
    
                    Object.keys(config.reports).forEach(report => {
                        // Verifica se o usuário logado possui permissão para ver o menu
                        const allowed = user.isDynamicGroup
                            ? config.reports[report].profiles['dynamics']
                            : config.reports[report].profiles[user.user_group]
    
                        if (allowed) {
                            filter.push({
                                label: 'Visualizar Relatórios ' + report,
                                link: 'relatorios.bi',
                                slug: 'vistualizar-relatorios-' + report,
                                params: { id: report },
                                allowed: true,
                                new: config.reports[report].new || false,
                                v2: true,
                                allowed_to: [],
                                allowed_to_except: [],
                                event: {
                                    event: "fac_button_click",
                                    category: "vuejs-visualizar relatorios",
                                    action: "click",
                                    label: "Visualizar relatorios de vendas"
                                }
                            })
                        }    
                    })
                }
    
                // Adiciona ao menu de relatórios, os submenus da categoria de relatórios BI
                let reportsMenu = payload.navigation.find(menu => menu.label === 'Relatórios')
                if (reportsMenu) {
                    let biCategory = reportsMenu.submenu.categories
                        .find(category => category.title === 'Relatórios BI')
                    if (biCategory) biCategory.navigation = biCategory.navigation.concat(filter)
                }
    
                storage.set('painel_menu', JSON.stringify(payload.navigation))
                commit('SET_MENU_CONFIG', payload.navigation)
            })
           
        }
    }
}